if (!customElements.get('wl-collection-controls')) {
  customElements.define('wl-collection-controls', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-wl-open]');
      if (!this.dialog || !this.openButton) return;
      this.openButton.hidden = false;
      this.sortButton = this.querySelector('.wl-sort-form button');
      if (this.sortButton) this.sortButton.hidden = true;
      this.onClick = event => {
        if (event.target.closest('[data-wl-open]')) {
          this.overflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
        if (event.target.closest('[data-wl-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      };
      this.onClose = () => {
        document.body.style.overflow = this.overflow || '';
        this.openButton.focus({preventScroll: true});
      };
      this.onChange = event => {
        if (event.target.matches('.wl-sort-form select')) event.target.form.requestSubmit();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.dialog.addEventListener('close', this.onClose);
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.body.style.overflow = this.overflow || '';
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.dialog?.removeEventListener('close', this.onClose);
    }
  });
}
